export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/11a14d9b63ec892bb84cea8c67204259.svg";